// extracted by mini-css-extract-plugin
export default {"mainPageStyle":"_1lvXkfps3Xg_5_A7PwjO7J","divider":"_2a5BriXgeFgwKk7d4GLhaO","searchHeader":"_1N4johJw4zBDJj7nHTtV1E"};